import api from "../../services/api";

const useBillingPurchases = () => {
  const getOptions = async () => {
    const { data } = await api.get("/billing/multi-term/options");
    return data;
  };

  const createCheckout = async (payload, idempotencyKey) => {
    const { data } = await api.post(
      "/billing/multi-term/checkout",
      payload,
      { headers: { "Idempotency-Key": idempotencyKey } }
    );
    return data;
  };

  const getRenewalOptions = async () => {
    const { data } = await api.get("/billing/manual-renewal/options");
    return data;
  };

  const createRenewalCheckout = async (payload, idempotencyKey) => {
    const { data } = await api.post(
      "/billing/manual-renewal/checkout",
      payload,
      { headers: { "Idempotency-Key": idempotencyKey } }
    );
    return data;
  };

  const getPurchase = async purchaseUuid => {
    const { data } = await api.get(
      `/billing/multi-term/purchases/${purchaseUuid}`
    );
    return data;
  };

  return {
    getOptions,
    createCheckout,
    getRenewalOptions,
    createRenewalCheckout,
    getPurchase
  };
};

export default useBillingPurchases;
